import api from '../../lib/api';

export const getPathwayPlan = pathway =>
  function get(dispatch) {
    api
      .sendGet(`/public-dashboard/plan?pathway=${pathway}`, (error, response) => {
        if (error) return console.error(error);
        dispatch(getPathwayPlanSuccess(response.data.data));
        return dispatch(getPathwayPlanIDSuccess(response.data.selected));
      });
  };

export const getPathwayPlanSuccess = data => ({
  type: 'GET_PATHWAY_PLAN_SUCCESS',
  data,
});

export const getPathwayPlanIDSuccess = data => ({
  type: 'GET_PATHWAY_PLAN_ID_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/pathwayplan.js